var map = {
	"./logo_hospital1.png": 9935,
	"./logo_hospital10.png": 3479,
	"./logo_hospital11.png": 1984,
	"./logo_hospital12.png": 2470,
	"./logo_hospital13.png": 162,
	"./logo_hospital14.png": 1832,
	"./logo_hospital15.png": 6700,
	"./logo_hospital16.png": 2877,
	"./logo_hospital17.png": 3017,
	"./logo_hospital18.png": 2191,
	"./logo_hospital19.png": 5185,
	"./logo_hospital2.png": 4730,
	"./logo_hospital20.png": 6429,
	"./logo_hospital21.png": 458,
	"./logo_hospital22.png": 7583,
	"./logo_hospital23.png": 7207,
	"./logo_hospital24.png": 642,
	"./logo_hospital25.png": 3466,
	"./logo_hospital26.png": 2189,
	"./logo_hospital27.png": 7275,
	"./logo_hospital28.png": 1260,
	"./logo_hospital29.png": 3795,
	"./logo_hospital3.png": 7409,
	"./logo_hospital30.png": 2485,
	"./logo_hospital31.png": 4250,
	"./logo_hospital32.png": 9268,
	"./logo_hospital33.png": 453,
	"./logo_hospital34.png": 8959,
	"./logo_hospital35.png": 3727,
	"./logo_hospital36.png": 6937,
	"./logo_hospital37.png": 2596,
	"./logo_hospital38.png": 7247,
	"./logo_hospital4.png": 733,
	"./logo_hospital5.png": 3344,
	"./logo_hospital6.png": 6955,
	"./logo_hospital7.png": 3935,
	"./logo_hospital8.png": 2177,
	"./logo_hospital9.png": 3414
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7927;